import {useState, useEffect,  useRef, useLayoutEffect} from 'react';
import {toastr} from "react-redux-toastr";


export function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
}

export function getElementDimensionsById(elementID) {
    const element = document.getElementById(elementID);
    if (_.isUndefined(element) || _.isNull(element))
        return { width: 0, height: 0 };
    const { offsetWidth: width, offsetHeight: height } = element;
    return { width, height };
}

export function useWindowDimensions() {
    const [dimensions, setDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return dimensions;
}

const isBrowser = typeof window !== 'undefined';

function getScrollPosition({ element, useWindow }) {
    if (!isBrowser) return { x: 0, y: 0 }

    const target = element ? element.current : document.body
    const position = target.getBoundingClientRect()

    return useWindow
        ? { x: window.scrollX, y: window.scrollY }
        : { x: position.left, y: position.top }
}

export function useScrollPosition(effect, deps, element, useWindow, wait) {
    const position = useRef(getScrollPosition({ useWindow }))

    let throttleTimeout = null

    const callBack = () => {
        const currPos = getScrollPosition({ element, useWindow })
        effect({ prevPos: position.current, currPos })
        position.current = currPos
        throttleTimeout = null
    }

    useLayoutEffect(() => {
        const handleScroll = () => {
            if (wait) {
                if (throttleTimeout === null) {
                    throttleTimeout = setTimeout(callBack, wait);
                }
            } else {
                callBack()
            }
        }

        window.addEventListener('scroll', handleScroll)

        return () => window.removeEventListener('scroll', handleScroll)
    }, deps)
}

export function setWindowScrollPosition(x = 0, y = 0) {
    window.scrollTo(x, y);
}

export const isOnline = (silent = false, lang) => {

    if (!navigator.onLine && silent === true) {
        toastr.warning(lang === "ru"
            ? "Вы не в сети. Пожалуйста, подключитесь к Интернету"
            : 'You are offline. Please connect to the Internet')
    }
    // console.log(lang)

    return navigator.onLine
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function kitcut( text, limit) {
    text = text.trim();
    if( text.length <= limit) return text;
    text = text.slice( 0, limit); // тупо отрезать по лимиту
    let lastSpace = text.lastIndexOf(" ");
    if( lastSpace > 0) { // нашлась граница слов, ещё укорачиваем
        text = text.slice(0, lastSpace);
    }
    return text + " ...";
}